module.exports = __webpack_public_path__ + "img/1573217020.6010c130.jpg";